import * as React from "react";
import * as locales from "../../../../locales.json";
import styled from "styled-components";
import { I18n } from "i18n-js";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import Modal from "../../../reusable/reactModal";
import { FlexConfirmModalProps } from "../lib/types";
import {
  StyledButton,
  StyledButtonContainer,
  StyledModalBody,
  StyledModalContents,
  StyledModalSubHeader,
  StyledModalText,
} from "../lib/styles";
import { getCardDisplayName } from "./creditCardPaymentMethod";
import { redesignTheme } from "../../../theme/theme";

const StyledDescription = styled(StyledModalText)`
  margin-bottom: ${redesignTheme.spacing[4.5]};
`;

const StyledInlineDescription = styled(StyledModalText)`
  display: inline;
`;

// NOTE: this will be used when we uncomment the syncing payment methods description below
// const StyledBoldDescription = styled(StyledInlineDescription)`
//   font-weight: ${redesignTheme.fontWeight.semibold};
//   padding-right: ${redesignTheme.spacing[1.5]};
// `;

const FlexConfirmModal = ({
  card,
  closeModal,
  modal,
  setModal,
}: FlexConfirmModalProps): React.ReactElement => {
  const cardType = getCardDisplayName(card.type);

  return (
    <Modal
      ariaLabel="confirm changes"
      close={closeModal}
      showDialog={modal === "flexConfirm"}
      testId="flex-confirm-modal"
      title={i18n.translate("admin_pages.settings.billing.switch_to_flex_plan")}
    >
      <StyledModalBody>
        <StyledModalContents>
          <StyledModalSubHeader>
            {i18n.translate(
              "admin_pages.settings.billing.confirm_changes_header"
            )}
          </StyledModalSubHeader>
          <StyledDescription>
            {i18n.translate(
              "admin_pages.settings.billing.confirm_changes_description"
            )}
          </StyledDescription>

          <div style={{ marginBottom: redesignTheme.spacing[4.5] }}>
            {/* NOTE: this will be added back if we decide to sync payment methods for subscription and rewards */}
            {/* <StyledBoldDescription>
              {i18n.translate(
                "admin_pages.settings.billing.confirm_changes_description2"
              )}
            </StyledBoldDescription> */}

            <StyledInlineDescription>
              {i18n.translate(
                "admin_pages.settings.billing.confirm_changes_description3",
                { cardType, last4: card.last4 }
              )}
            </StyledInlineDescription>
          </div>

          <StyledDescription>
            {i18n.translate(
              "admin_pages.settings.billing.confirm_changes_description4"
            )}
          </StyledDescription>
        </StyledModalContents>
        <StyledButtonContainer>
          <StyledButton
            onClick={closeModal}
            size="small"
            testId="cancel-button"
            variant="secondary"
          >
            {i18n.translate("forms.cancel")}
          </StyledButton>
          <StyledButton
            onClick={() => setModal("flexPayment")}
            size="small"
            testId="understand-button"
            variant="primary"
          >
            {i18n.translate("forms.understand")}
          </StyledButton>
        </StyledButtonContainer>
      </StyledModalBody>
    </Modal>
  );
};

export default FlexConfirmModal;
